import type { NextPage, NextPageContext } from 'next'
import Link from 'next/link'
import { Trans, useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import nextI18NextConfig from '../next-i18next.config.js'
import Footer from '../components/footer'
import LanguageSelector from '../components/LanguageSelector'
import PrivacyPolicy_ES_ES from '../components/PrivacyPolicy.es'
import PrivacyPolicy_EN_US from '../components/PrivacyPolicy.en'
import { resolveLocale } from '../components/i18n'


const PrivacyPolicy: NextPage = () => {

    const { t, i18n } = useTranslation()

    return (
        <div className="landing-page">
            <div className="page-wrapper">
                <nav className="navbar">
                    <div className="container">
                        <div className="left">
                            <Link href="/"><a><img alt="IUVIA" src="./images/logos/iuvia.svg" /></a></Link>
                        </div>
                        <div className="right">
                            <LanguageSelector t={t} i18n={i18n} />
                        </div>
                    </div>
                </nav>
                <div className="page-wrapper">
                    <div className="container">
                        <main className="privacy-policy-main">
                            {
                                i18n.language === "es-ES" ? <PrivacyPolicy_ES_ES /> : <PrivacyPolicy_EN_US />
                            }
                        </main>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export async function getServerSideProps(
    nextPageContext: NextPageContext
): Promise<{ props: { resolvedLocale: string } }> {
    const resolvedLocale = resolveLocale(nextPageContext)

    return {
        props: {
            resolvedLocale,
            ...await serverSideTranslations(resolvedLocale as string, ['common'])
        }
    }
}


export default PrivacyPolicy
